import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider.jsx';
import { FullScreenLoader } from '../components/ui/FullScreenLoader.jsx';

/**
 * Post login dispatcher. Sends each principal to the surface that
 * matches their role. Owner and admin land on the admin dashboard,
 * sellers on the employee surface, anonymous users on the login page,
 * baseline users on the account self management surface.
 */
export function RoleRedirect() {
  const { status, role } = useAuth();
  if (status === 'loading') return <FullScreenLoader />;
  if (status !== 'authenticated') return <Navigate to="/login" replace />;

  switch (role) {
    case 'owner':
    case 'admin':
      return <Navigate to="/admin" replace />;
    case 'seller':
      return <Navigate to="/employee" replace />;
    case 'kiosk':
      return <Navigate to="/kiosk" replace />;
    case 'user':
    default:
      return <Navigate to="/account" replace />;
  }
}
